

























import { defineComponent } from '@vue/composition-api';
import { FCCard } from '@fc/angie-ui';

export default defineComponent({
  name: 'MemberQuoteCard',
  components: {
    FCCard,
  },
  props: {
    quote: {
      type: String,
      required: true,
    },
    memberName: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    bgColor: {
      type: String,
      required: false,
      default: 'blue',
    },
  },
  setup(props: any) {
    const nameColorClass = props.bgColor === 'red' ? 'member-quote-card__name--white' : '';

    return {
      nameColorClass,
    };
  },
});
